/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum APIPaths {
  USER_AUTH_LOGIN = '/api/user/auth/login',
  USER_AUTH_LOGOUT = '/api/user/auth/logout',
  USER_AUTH_REFRESH = '/api/user/auth/refresh',

  USER = '/api/user/user/current',
  LOCALE = '/api/user/user/change-language',

  SALESMAN_SUGGEST_DETAIL = '/api/sales/salesman/suggest/:salesmanId',

  SALESMEN_SUGGEST = '/api/sales/salesmen/suggest',

  SALESMEN_ELIGIBLE_EMPLOYEES = '/api/sales/salesmen/eligible-employees',

  SALES_CASES_DATATABLE = '/api/sales/sales-cases',
  SALES_CASES_KANBAN = '/api/sales/sales-cases/kanban',
  SALES_CASES_MAP = '/api/sales/sales-cases/map',
  SALES_CASES_SUMMARY = '/api/sales/sales-cases/summary',
  SALES_CASES_DELETE = '/api/sales/sales-cases/delete',
  SALES_CASES_CAMPAIGNS = '/api/sales/sales-cases/campaigns',

  SALES_CASE_MERGE = '/api/sales/sales-case/:salesCaseId/merge',
  SALES_CASE_CHANGE_SALESMAN = '/api/sales/sales-case/:salesCaseId/change-salesman',
  SALES_CASE_CHANGE_POTENTIAL = '/api/sales/sales-case/:salesCaseId/change-potential',
  SALES_CASE_CHANGE_STATUS = '/api/sales/sales-case/:salesCaseId/change-status',
  SALES_CASE_DISQUALIFY = '/api/sales/sales-case/:salesCaseId/disqualify',
  SALES_CASE_MARK_AS_LOST = '/api/sales/sales-case/:salesCaseId/lost',
  SALES_CASE_LEAD_CREATE = '/api/sales/sales-case/lead',
  SALES_CASE_DEAL_CREATE = '/api/sales/sales-case/deal',
  SALES_CASE_OFFER_CREATE = '/api/sales/sales-case/offer',
  SALES_CASE_OFFER_CALCULATE = '/api/sales/sales-case/offer/calculate',
  SALES_CASE_OFFER_SUMMARY = '/api/sales/sales-case/offer/:offerId/summary',
  SALES_CASE_OFFER_DETAIL = '/api/sales/sales-case/offer/:offerId/detail',
  SALES_CASE_OFFER_PDF = '/api/sales/sales-case/offer/:offerId/pdf',
  SALES_CASE_OFFER_SEND = '/api/sales/sales-case/offer/:offerId/send',
  SALES_CASE_OFFER_UPDATE = '/api/sales/sales-case/offer/:offerId',
  SALES_CASE_OFFER_DELETE = '/api/sales/sales-case/:salesCaseId/offer/:offerId',
  SALES_CASE_DETAIL = '/api/sales/sales-case/:salesCaseId',
  SALES_CASE_BY_LEAD = '/api/sales/sales-case/by-lead/:leadId',
  SALES_CASE_HISTORY = '/api/sales/sales-case/:salesCaseId/history',
  SALES_CASE_NOTES = '/api/sales/sales-case/:salesCaseId/notes',
  SALES_CASE_CHANGELOG = '/api/sales/sales-case/:salesCaseId/changelog',
  SALES_CASE_NOTE_CREATE = '/api/sales/sales-case/:salesCaseId/note',
  SALES_CASE_NOTE_UPDATE = '/api/sales/sales-case/:salesCaseId/note/:noteId',
  SALES_CASE_NOTE_DELETE = '/api/sales/sales-case/:salesCaseId/note/:noteId',
  SALES_CASE_RENEW = '/api/sales/sales-case/:salesCaseId/renew',
  SALES_CASE_DELETE = '/api/sales/sales-case/:salesCaseId/delete',
  SALES_CASE_SCHEDULED_ACTIVITIES = '/api/sales/sales-case/:salesCaseId/scheduled-activities',
  SALES_CASE_SCHEDULE_ACTIVITY = '/api/sales/sales-case/:salesCaseId/schedule-activity',
  SALES_CASE_UPDATE_SCHEDULED_ACTIVITY = '/api/sales/sales-case/:salesCaseId/scheduled-activity/:scheduledActivityId',
  SALES_CASE_COMPLETE_SCHEDULED_ACTIVITY = '/api/sales/sales-case/:salesCaseId/scheduled-activity/:scheduledActivityId/complete',
  SALES_CASE_MARK_SCHEDULED_ACTIVITY_AS_INCOMPLETE = '/api/sales/sales-case/:salesCaseId/scheduled-activity/:scheduledActivityId/mark-incomplete',
  SALES_CASE_CANCEL_SCHEDULED_ACTIVITY = '/api/sales/sales-case/:salesCaseId/scheduled-activity/:scheduledActivityId/cancel',
  SALES_CASE_UPDATE_LEAD = '/api/sales/sales-case/:salesCaseId/update-lead',
  SALES_CASE_UPDATE_PROPERTY = '/api/sales/sales-case/:salesCaseId/update-property',
  SALES_CASE_CONVERT_TO_DEAL = '/api/sales/sales-case/:salesCaseId/convert-to-deal',
  SALES_CASE_CONVERT_TO_LEAD = '/api/sales/sales-case/:salesCaseId/convert-to-lead',
  SALES_CASE_STAGE_MOVE_TO_OFFER = '/api/sales/sales-case/:salesCaseId/move-to-offer-stage',
  SALES_CASE_START_IMPLEMENTATION = '/api/sales/sales-case/:salesCaseId/start-implementation',
  SALES_CASE_CONTINUE_IMPLEMENTATION = '/api/sales/sales-case/:salesCaseId/continue-implementation',
  SALES_CASE_FINISH_IMPLEMENTATION = '/api/sales/sales-case/:salesCaseId/finish-implementation',
  SALES_CASE_IMPLEMENTATION = '/api/sales/sales-case/:salesCaseId/implementation',
  SALES_CASE_IMPLEMENTATION_INVOICING_SETTINGS = '/api/sales/sales-case/:salesCaseId/implementation/invoicing-settings',
  SALES_CASE_IMPLEMENTATION_SALES_INVOICES = '/api/sales/sales-case/:salesCaseId/implementation/sales-invoices',
  SALES_CASE_IMPLEMENTATION_TASKS = '/api/sales/sales-case/:salesCaseId/implementation/tasks',
  SALES_CASE_IMPLEMENTATION_TASK = '/api/sales/sales-case/:salesCaseId/implementation/tasks/:taskId',
  SALES_CASE_LINK_NEW_PROPERTY = '/api/sales/sales-case/:salesCaseId/link-new-property',
  SALES_CASE_LINK_PROPERTY = '/api/sales/sales-case/:salesCaseId/link-property',
  SALES_CASE_REPLACE_PROPERTY = '/api/sales/sales-case/:salesCaseId/replace-property',
  SALES_CASE_UNLINK_PROPERTY = '/api/sales/sales-case/:salesCaseId/unlink-property',
  SALES_CASE_LINK_CONTACT_PERSON = '/api/sales/sales-case/:salesCaseId/link-contact-person',
  SALES_CASE_UNLINK_CONTACT_PERSON = '/api/sales/sales-case/:salesCaseId/unlink-contact-person',
  SALES_CASE_UPDATE_LEAD_CONTACT = '/api/sales/sales-case/:salesCaseId/update-lead-contact',

  SCHEDULED_ACTIVITY_DETAIL = '/api/sales/scheduled-activity/:scheduledActivityId',

  SALES_DASHBOARD_SALES_CASES = '/api/sales/dashboard/sales-cases',
  SALES_DASHBOARD_STAGE_MOVEMENTS = '/api/sales/dashboard/stage-movements',
  SALES_DASHBOARD_STAGE_MOVEMENTS_CHANGE_LOG = '/api/sales/dashboard/stage-movements/change-log',
  SALES_DASHBOARD_LOST_CASES = '/api/sales/dashboard/lost-cases',
  SALES_DASHBOARD_ACTIVITIES = '/api/sales/dashboard/activities',
  SALES_DASHBOARD_ACTIVITIES_COMPLETED = '/api/sales/dashboard/activities/completed',
  SALES_DASHBOARD_ACTIVITIES_CREATED = '/api/sales/dashboard/activities/created',
  SALES_DASHBOARD_ACTIVITIES_OPEN = '/api/sales/dashboard/activities/open',
  SALES_DASHBOARD_RISKY_CASES = '/api/sales/dashboard/risky-cases',

  CALENDAR_STATUS = '/api/calendar/status',
  CALENDAR_AUTH_URL = '/api/calendar/auth-url',
  CALENDAR_EVENTS = '/api/calendar/events',

  PROPERTY_SUGGEST_DETAIL = '/api/backoffice/property/suggest/:propertyId',

  PROPERTIES_SUGGEST = '/api/backoffice/properties/suggest',
  PROPERTIES_SEARCH = '/api/backoffice/properties/search',

  PROPERTY_GROUPS_OPTIONS = '/api/backoffice/property-groups/options',

  ZIPS_SUGGEST = '/api/backoffice/zips/suggest',
  ZIP_DETAIL = '/api/backoffice/zip/:zipId',

  CONTACT_PERSON_DETAIL = '/api/backoffice/contact-person/:contactPersonId',
  CONTACT_PERSON_DELETE = '/api/backoffice/contact-person/:contactPersonId',
  CONTACT_PERSON_UPDATE = '/api/backoffice/contact-person/:contactPersonId',
  CONTACT_PERSON_CREATE = '/api/backoffice/contact-person',
  CONTACT_PERSON_CHANGE_PROPERTY = '/api/backoffice/contact-person/:contactPersonId/change-property',
  CONTACT_PERSON_SUGGEST_DETAIL = '/api/backoffice/contact-person/suggest/:contactPersonId',

  CONTACT_PERSONS_DATATABLE = '/api/backoffice/contact-persons',
  CONTACT_PERSONS_SEARCH = '/api/backoffice/contact-persons/search',
  CONTACT_PERSONS_DELETE = '/api/backoffice/contact-persons/delete',
  CONTACT_PERSONS_EXPORT = '/api/backoffice/contact-persons/export',
  CONTACT_PERSONS_SUGGEST = '/api/backoffice/contact-persons/suggest',

  CONTRACTS_DATATABLE = '/api/sales/contracts',
  CONTRACTS_UPLOAD = '/api/sales/contracts/property/:propertyId',
  CONTRACTS_DOWNLOAD = '/api/sales/contracts/download',
  CONTRACTS_DELETE = '/api/sales/contracts/delete',
  REFERENCE_SETS_DATATABLE = '/api/sales/reference-sets',
  REFERENCE_SETS_SUGGEST = '/api/sales/reference-sets/suggest',
  REFERENCE_SET_CREATE = '/api/sales/reference-set',
  REFERENCE_SET_SUGGEST_DETAIL = '/api/sales/reference-set/suggest/:referenceSetId',
  REFERENCE_SET_DETAIL = '/api/sales/reference-set/:referenceSetId',
  REFERENCE_SET_UPDATE = '/api/sales/reference-set/:referenceSetId',
  REFERENCE_SET_DELETE = '/api/sales/reference-set/:referenceSetId',
  REFERENCE_SET_PHOTO_UPLOAD = '/api/sales/reference-set-photo/property/:propertyId',
  OFFER_SETTINGS_PHOTO_UPLOAD = '/api/sales/offer-settings-photo',

  EMPLOYEES_DATATABLE = '/api/backoffice/employees',
  EMPLOYEE_DETAIL = '/api/backoffice/employee/:employeeId',
  EMPLOYEE_CREATE = '/api/backoffice/employee',
  EMPLOYEE_UPDATE = '/api/backoffice/employee/:employeeId',
  EMPLOYEE_DEACTIVATE = '/api/backoffice/employee/:employeeId/deactivate',
  EMPLOYEE_RESEND_INVITATION = '/api/backoffice/employee/:employeeId/resend-invitation',
  EMPLOYEE_ACTIVITY_HISTORY = '/api/backoffice/employee/:employeeId/activity-history',
  USER_ACTIVITY_DATATABLE = '/api/backoffice/user-activity',
  USER_ACTIVITY_USERNAMES = '/api/backoffice/user-activity/usernames',

  API_USERS_LIST = '/api/backoffice/api-users',
  API_USERS_INTEGRATION_PARTNERS = '/api/backoffice/api-users/integration-partners',
  API_USERS_OTA_PARTNERS = '/api/backoffice/api-users/ota-partners',
  API_USER_DETAIL = '/api/backoffice/api-user/:apiUserId',
  API_USER_CREATE = '/api/backoffice/api-user',
  API_USER_UPDATE = '/api/backoffice/api-user/:apiUserId',
  API_USER_DEACTIVATE = '/api/backoffice/api-user/:apiUserId/deactivate',
  API_USER_API_KEYS = '/api/backoffice/api-user/:apiUserId/api-keys',
  API_USER_API_KEY = '/api/backoffice/api-user/:apiUserId/api-keys/:keyId',
  API_USER_PERMISSIONS = '/api/backoffice/api-user/:apiUserId/permissions',
  API_USER_PERMISSIONS_AVAILABLE = '/api/backoffice/api-user/:apiUserId/permissions/available',
  API_USER_PERMISSION = '/api/backoffice/api-user/:apiUserId/permissions/:moduleCode',
  API_USER_PROPERTIES = '/api/backoffice/api-user/:apiUserId/properties',
  API_USER_PROPERTY = '/api/backoffice/api-user/:apiUserId/properties/:propertyId',
  API_USER_IP_RULES = '/api/backoffice/api-user/:apiUserId/ip-rules',
  API_USER_ACTIVITY_HISTORY = '/api/backoffice/api-user/:apiUserId/activity-history',

  USER_GROUPS_DATA_TABLE = '/api/backoffice/property-groups',
  USER_GROUPS_SUGGEST = '/api/backoffice/property-groups/suggest',
  USER_GROUPS_LEFT_EMPTY = '/api/backoffice/property-groups/left-empty',
  USER_GROUP_CREATE = '/api/backoffice/property-group',
  USER_GROUP_DETAIL = '/api/backoffice/property-group/:propertyGroupId',
  USER_GROUP_RENAME = '/api/backoffice/property-group/:propertyGroupId',
  USER_GROUP_DELETE = '/api/backoffice/property-group/:propertyGroupId',
  USER_GROUP_MERGE = '/api/backoffice/property-group/:propertyGroupId/merge',
  USER_GROUP_USERS = '/api/backoffice/property-group/:propertyGroupId/users',
  USER_GROUP_USER_MOVE = '/api/backoffice/property-group/:propertyGroupId/users/:userId/move',
  USER_GROUP_PROPERTIES = '/api/backoffice/property-group/:propertyGroupId/properties',
  USER_GROUP_PROPERTY_MOVE = '/api/backoffice/property-group/:propertyGroupId/properties/:propertyId/move',
  USER_GROUP_MODULES = '/api/backoffice/property-group/:propertyGroupId/modules',
  USERS_SUGGEST = '/api/backoffice/users/suggest',

  PMS_VERSION_OVERRIDES_DATATABLE = '/api/backoffice/pms-version-overrides',
  PMS_VERSION_OVERRIDES_USERS = '/api/backoffice/pms-version-overrides/users',
  PMS_VERSION_OVERRIDES_FORCE = '/api/backoffice/pms-version-overrides/force',
  PMS_VERSION_OVERRIDES_RELEASE = '/api/backoffice/pms-version-overrides/release',
  PMS_VERSION_OVERRIDES_REACTIVATE = '/api/backoffice/pms-version-overrides/reactivate',
  PMS_VERSION_OVERRIDES_LOCK = '/api/backoffice/pms-version-overrides/lock',
  PMS_VERSION_OVERRIDES_ALLOW = '/api/backoffice/pms-version-overrides/allow',
  PMS_VERSION_OVERRIDES_DELETE = '/api/backoffice/pms-version-overrides',
  PMS_VERSION_OVERRIDE_STATISTICS_SUMMARY = '/api/backoffice/pms-version-overrides/statistics/summary',
  PMS_VERSION_OVERRIDE_STATISTICS_WAVES = '/api/backoffice/pms-version-overrides/statistics/waves',
  PMS_VERSION_OVERRIDE_STATISTICS_WAVE_MEMBERS = '/api/backoffice/pms-version-overrides/statistics/waves/:batch/members',

  SALESMEN_LIST = '/api/sales/salesmen',
  SALESMAN_DETAIL = '/api/sales/salesman/:salesmanId',
  SALESMAN_CREATE = '/api/sales/salesman',
  SALESMAN_UPDATE = '/api/sales/salesman/:salesmanId',
  SALESMAN_DELETE = '/api/sales/salesman/:salesmanId',
  SALESMAN_ACTIVITY_HISTORY = '/api/sales/salesman/:salesmanId/activity-history',
  SALESMAN_CALENDAR_STATUS = '/api/sales/salesman/:salesmanId/calendar-status',
  SALESMAN_CALENDAR_DISCONNECT = '/api/sales/salesman/:salesmanId/calendar-connection',

  INTEGRATION_PARTNERS_DATATABLE = '/api/backoffice/integration-partners',
  INTEGRATION_PARTNER_CREATE = '/api/backoffice/integration-partner',
  INTEGRATION_PARTNER_UPDATE = '/api/backoffice/integration-partner/:integrationPartnerId',
  INTEGRATION_PARTNER_DELETE = '/api/backoffice/integration-partner/:integrationPartnerId',
  INTEGRATION_PARTNER_FILE_UPLOAD = '/api/backoffice/integration-partner-file/partner/:integrationPartnerId/:kind',
  INTEGRATION_PARTNER_FILE_DELETE = '/api/backoffice/integration-partner-file/partner/:integrationPartnerId/:kind',
  INTEGRATION_PARTNER_DOCUMENT_URL = '/api/backoffice/integration-partner-file/partner/:integrationPartnerId/document/url',

  PLACES_AUTOCOMPLETE = '/api/places/autocomplete',

  CHM_CONNECTIONS_DATATABLE = '/api/ota/chm-connections',
  CHM_CONNECTIONS_EXPORT = '/api/ota/chm-connections/export',
  CHM_CONNECTIONS_PARTNERS = '/api/ota/chm-connections/partners',

  RESERVATION_ROOM_LOOKUP = '/api/ota/reservation-room-lookup',
  ICAL_VIEWER = '/api/ota/ical-viewer',

  NTAK_VERSION_HOTELS = '/api/system/ntak-version/hotels',
  NTAK_VERSION_CHECK = '/api/system/ntak-version/check',
  NTAK_VERSION_SWITCH = '/api/system/ntak-version/switch',
  NTAK_VERSION_CONNECTION_TEST = '/api/system/ntak-version/connection-test',
}
